module.exports = __webpack_public_path__ + "static/img/feedback.24a62233.svg";